import React from "react";
import DocumentCard from "components/card/DocumentCard";
import { FileText } from "lucide-react";

export const documents = [
    {
        title: "Annual Salary Review 2024",
        type: "Compensation",
        description: "Annual salary adjustment and benefits update.",
        date: "2024-01-10",
        effectiveDate: "January 15, 2024",
        size: "980 KB",
        status: "Active",
        icon: <FileText className="w-5 h-5 text-emerald-600" />,
        docID: "DOC004",
        prevSalary: "$85,000",
        newSalary: "$95,000",
        increase: "+11.8%",

    },
    {
        title: "Performance Bonus - Q4 2023",
        type: "Compensation",
        description: "Quarterly performance bonus letter.",
        date: "2023-12-20",
        size: "750 KB",
        status: "Completed",
        icon: <FileText className="w-5 h-5 text-emerald-600" />,
        docID: "DOC004",
        bonus: "$5,000",
        reason: "Outstanding Q4 project delivery",
    },
    {
        title: "Salary Adjustment - Promotion",
        type: "Compensation",
        description: "Compensation change accompanying promotion to Senior Developer.",
        date: "2024-03-01",
        effectiveDate: "March 1, 2024",
        size: "1.1 MB",
        status: "Active",
        icon: <FileText className="w-5 h-5 text-emerald-600" />,
        prevSalary: "$75,000",
        newSalary: "$85,000",
        increase: "+13.3%",
    },
];

const CompensationDocument = () => {

    return (
        <div className="space-y-3">
            {documents.map((doc, index) => (
                <DocumentCard
                    key={index}
                    {...doc}
                    documentData={doc}
                    onDownload={() => console.log(`Download ${doc.title}`)}
                />
            ))}
        </div>
    );
};

export default CompensationDocument;
